import { createRouter, createWebHistory } from 'vue-router'
import ActiveIncidents from '../views/ActiveIncidents.vue'
import DisclaimerSiteInfo from '../views/DisclaimerSiteInfo.vue'
import GlossaryPage from '../views/GlossaryPage.vue'
import FireStations from '../views/FireStations.vue'

const Statistics = () => import('../views/OverviewStats.vue')    // lazy load.

const routes = [
  {
    path: '/',
    name: 'active-incidents',
    component: ActiveIncidents
  },
  {
    path: '/fire-stations',
    name: 'fire-stations',
    component: FireStations
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: Statistics
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: DisclaimerSiteInfo
  },
  {
    path: '/glossary',
    name: 'glossary',
    component: GlossaryPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 